module.exports = __webpack_public_path__ + "static/media/RidiculeRemi.2bb4c176.png";